export default [
  //  role is  >>
  //   "admin","government", "manager","super-manager","process-manager","hr","hr-office","accountant",
  // "super-accountant","markter",engineer-allocation,engineer, "office-manager", "quality"

  // permissions is >>
  // "salary", "salary_by_office", "crm-marketing", "crm-marketing-admin", "crm-marketing-branch",
  // "personnel-evaluation-external-by-office" , "applications-analytics" , "complaint", "complaint_by_office",
  // "manage-halal-shipments" , "training" , "operations-center"
  {
    title: 'Home',
    route: 'dashboard',
    icon: 'fa-solid fa-house',
    role: [
      'admin',
      'government',
      'manager',
      'process-manager',
      'hr',
      'hr-office',
      'accountant',
      'super-accountant',
      'markter',
      'engineer-allocation',
      'office-manager',
      'quality',
    ],
  },
  {
    title: 'Home',
    route: 'dashboard',
    img: 'home.svg',
    role: ['super-manager'],
  },
  {
    title: 'CRM System',
    route: 'crm-system',
    img: 'crm.png',
    role: ['manager', 'super-manager'],
    permissions: [
      'crm-marketing',
      'crm-marketing-admin',
      'crm-marketing-branch',
    ],
  },
  {
    title: 'Applications Analytics',
    route: 'applications-analytics',
    icon: 'fa-solid fa-chart-line',
    role: ['super-manager', 'manager', 'admin'],
    permissions: ['applications-analytics'],
  },
  {
    title: 'Workflow Center',
    icon: 'fa-solid fa-school',
    children: [
      {
        title: 'Requests',
        icon: 'fa-solid fa-file-circle-plus',
        route: 'requests',
        role: [
          'admin',
          'manager',
          'process-manager',
          'markter',
          'engineer-allocation',
          'office-manager',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Requests Pending',
        icon: 'fa-solid fa-file-export',
        route: 'requests-pending',
        role: [
          'admin',
          'manager',
          'process-manager',
          'markter',
          'engineer-allocation',
          'office-manager',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Requests In Turn',
        icon: 'fa-solid fa-file-import',
        route: 'requests-in-turn',
        role: [
          'admin',
          'manager',
          'process-manager',
          'markter',
          'engineer-allocation',
          'office-manager',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'unassigned Requests',
        icon: 'fa-solid fa-file-excel',
        route: 'requests-unassigned',
        role: [
          'admin',
          'manager',
          'process-manager',
          'markter',
          'engineer-allocation',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Overdue Requests',
        icon: 'fa-solid fa-triangle-exclamation',
        route: 'requests-over-due',
        role: [
          'admin',
          'manager',
          'process-manager',
          'markter',
          'engineer-allocation',
          'office-manager',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Delay Justifications',
        route: 'late-reasons',
        icon: 'fa-solid fa-question',

        action: 'browes',
        role: [
          'admin',
          'manager',
          'process-manager',
          'office-manager',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Fasah Upload Certificate',
        route: 'fasah-certificate',
        icon: 'fa-solid fa-file',
        action: 'browes',
        role: ['admin', 'manager', 'process-manager', 'engineer'],
      },
    ],
  },
  {
    title: 'People Hub',
    icon: 'fa-solid fa-users',
    role: [
      'admin',
      'manager',
      'process-manager',
      'hr',
      'hr-office',
      'super-manager',
    ],
    children: [
      {
        title: 'USERS',
        route: 'user-site',
        icon: 'fa-solid fa-person',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'process-manager',
          'hr',
          'hr-office',
          'super-manager',
          'office-manager',
        ],
      },
      {
        title: 'Assets',
        route: 'devices',
        icon: 'fa-solid fa-desktop',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },
      {
        title: 'Engineer Setup',
        route: 'engineers',
        icon: 'fa-solid fa-person-circle-check',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'process-manager',
          'hr',
          'hr-office',
          'super-manager',
        ],
        permissions: ['training'],
      },
      {
        title: 'New People',
        route: 'employees',
        icon: 'fa-solid fa-person-through-window',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },
      {
        title: 'office',
        route: 'office',
        icon: 'fa-solid fa-building',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'hr',
          'hr-office',
          'super-manager',
          'office-manager',
        ],
      },
      {
        title: 'Training',
        route: 'training',
        icon: 'fa-solid fa-chalkboard-user',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
        permissions: ['training'],
      },
      {
        title: 'Session Training',
        route: 'sessions-training',
        icon: 'fa-solid fa-person-chalkboard',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
        permissions: ['training'],
      },
    ],
  },
  {
    title: 'Process Settings',
    icon: 'fa-solid fa-screwdriver-wrench',
    role: ['admin', 'manager', 'super-manager'],
    children: [
      {
        title: 'Certificate',
        route: 'main-certificate',
        icon: 'fa-solid fa-certificate',
        // fa-solid
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Group Certificate',
        route: 'group-certificate',
        icon: 'fa-solid fa-object-ungroup',
        // fa-solid
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Type Certificate',
        route: 'type-certificate',
        icon: 'fa-solid fa-object-group',
        // fa-solid
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'certificate & product',
        route: 'product-and-certificate',
        icon: 'fa-solid fa-diagram-project',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Departments',
        route: 'departments',
        icon: 'fa-solid fa-industry',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },
      {
        title: 'Post',
        icon: 'fa-solid fa-newspaper',
        route: 'post',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },

      {
        title: 'Product Category',
        route: 'product',
        icon: 'fa-brands fa-product-hunt',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Source Account',
        route: 'source-account',
        icon: 'fa-regular fa-address-card',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Manufacture White',
        route: 'manufacture-white',
        icon: 'fa-solid fa-shop',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager', 'engineer-allocation'],
      },
      {
        title: 'HS Code',
        route: 'hs-code',
        icon: 'fa-solid fa-box-open',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager', 'engineer'],
      },
      {
        title: 'SFDA Labs',
        route: 'sfda-labs',
        icon: 'fa-solid fa-flask',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager', 'engineer-allocation'],
      },
      {
        title: 'SFDA Sources',
        route: 'sfda-sources',
        icon: 'fa-solid fa-diagram-successor',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Permission',
        route: 'permission',
        icon: 'fa-solid fa-shield-virus',
        action: 'browes',
        role: ['super-manager', 'admin'],
      },
      {
        title: 'Active Sessions',
        route: 'active-sessions',
        icon: 'fa-solid fa-right-from-bracket',
        action: 'browes',
        role: ['super-manager', 'admin'],
      },
      {
        title: 'Halal Certificate',
        img: 'halal.svg',
        action: 'browes',
        role: ['super-manager', 'admin', 'manager', 'halal-template'],
        children: [
          {
            title: 'Check List',
            route: 'halal-check-list',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin', 'halal-template'],
          },
          {
            title: 'Documentary Requirements',
            route: 'halal-documentary-requirements',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin', 'halal-template'],
          },
          {
            title: 'Templates',
            route: 'halal-templates',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin', 'halal-template'],
          },
          {
            title: 'Other Forms',
            route: 'halal-other-forms',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin', 'halal-template'],
          },
          {
            title: 'Halal CE',
            route: 'halal-operation-engineers',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin'],
          },
          {
            title: 'Head of operations/ CE',
            route: 'head-of-operations',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin'],
          },
          {
            title: 'Decision Committee',
            route: 'halal-decision-committee',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin', 'halal-template'],
          },
          {
            title: 'Kuwait Halal Shipment',
            route: 'halal-shipment',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'manage-halal-shipments'],
          },
        ],
      },
      {
        title: 'ISO Certificate',
        img: 'iso.png',
        action: 'browes',
        role: ['super-manager', 'admin', 'manager'],
        children: [
          {
            title: 'Templates',
            route: 'iso-templates',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin'],
          },
          {
            title: 'Scope Codes',
            route: 'iso-scope-codes',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin'],
          },
          {
            title: 'Assign Personal',
            route: 'iso-assign-personal',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['super-manager', 'admin'],
          },
        ],
      },
    ],
  },
  {
    title: 'Audit & Inspection',
    icon: 'fa-solid fa-ticket-simple',
    role: ['admin', 'manager', 'super-manager'],
    children: [
      {
        title: 'All Service',
        route: 'all-service',
        icon: 'fa-brands fa-servicestack',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },
      {
        title: 'Service Need Approval',
        route: 'service-need-approval',
        icon: 'fa-solid fa-person-circle-check',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Service Need Set Money',
        route: 'service-need-set-money',
        icon: 'fa-solid fa-money-check',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager'],
      },
      {
        title: 'Audit',
        route: 'audit-assigned',
        icon: 'fa-regular fa-building',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },
      {
        title: 'Internal Audit',
        route: 'internal-audit',
        icon: 'fa-solid fa-building-user',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
      },
      {
        title: 'Request Inspection',
        icon: 'fa-solid fa-person-shelter',
        action: 'browes',
        role: ['admin', 'manager', 'hr', 'hr-office', 'super-manager'],
        children: [
          {
            title: 'Completed',
            route: 'request-inspection-completed',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['admin', 'hr', 'hr-office', 'super-manager'],
          },
          {
            title: 'Pending',
            route: 'request-inspection-pending',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['admin', 'hr', 'hr-office', 'super-manager'],
          },
        ],
      },
    ],
  },
  {
    title: 'HR',
    icon: 'fa-solid fa-user-tie',
    role: ['admin', 'manager', 'super-manager'],
    children: [
      {
        title: 'Personnel Evaluation',
        icon: 'fa-solid fa-square-poll-vertical',
        route: 'personnel-evaluation-master-list',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'hr',
          'hr-office',
          'quality',
          'super-manager',
          // Karim, 2026-09-24: holders see all of PE (internal + external), not only
          // Inspectors Evaluations. Backend route gate opened to the same permission.
          'personnel-evaluation-external',
        ],
      },
      {
        // Karim, 13 Sep: "Inspectors Evaluations" — externally contracted inspectors get
        // their own section (users.is_internal_employee = 0), same PE component and endpoint,
        // only the `employment` route meta differs. Permission tiers mirror Salary/CRM
        // (view-all vs. by-office) — additive, the roles below still work unchanged.
        title: 'Inspectors Evaluations',
        icon: 'fa-solid fa-user-shield',
        route: 'personnel-evaluation-external',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'hr',
          'hr-office',
          'quality',
          'super-manager',
        ],
        permissions: [
          'personnel-evaluation-external',
          'personnel-evaluation-external-by-office',
        ],
      },

      {
        title: 'Performance Evaluation',
        icon: 'fa-solid fa-chart-simple',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'hr',
          'hr-office',
          'quality',
          'super-manager',
        ],
        children: [
          {
            title: 'Under HR',
            route: 'performance-evaluation',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['admin', 'hr', 'hr-office', 'quality', 'super-manager'],
          },
          {
            title: 'ERP Master Data',
            route: 'performance-evaluation-done',
            icon: 'fa-regular fa-circle',
            action: 'browes',
            role: ['admin', 'hr', 'hr-office', 'quality', 'super-manager'],
          },
        ],
      },
      {
        title: 'Vacation',
        icon: 'fa-regular fa-calendar-days',
        route: 'schedule',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'hr',
          'hr-office',
          'office-manager',
          'super-manager',
          'engineer-allocation',
          'engineer',
          'quality',
        ],
      },
      {
        title: 'Loan',
        icon: 'fa-solid fa-money-check-dollar',
        route: 'loan',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'hr',
          'hr-office',
          'office-manager',
          'super-manager',
        ],
      },

      {
        title: 'Reimbursement',
        icon: 'fa-solid fa-money-bill-transfer',
        route: 'reimbursement',
        action: 'browes',
        role: ['admin', 'office-manager', 'hr', 'hr-office'],
      },
    ],
  },
  {
    title: 'Sales',
    icon: 'fa-regular fa-credit-card',
    role: ['admin', 'manager', 'super-manager'],
    children: [
      {
        title: 'Offer',
        route: 'offer',
        icon: 'fa-solid fa-money-bill',
        action: 'browes',
        role: ['admin', 'manager', 'markter', 'super-manager'],
      },
      {
        title: 'Client',
        route: 'delegator',
        icon: 'fa-solid fa-user-tag',
        action: 'browes',
        role: ['admin', 'manager', 'markter', 'super-manager'],
      },
      {
        title: 'Importers',
        route: 'importer',
        icon: 'fa-solid fa-truck-fast',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'markter',
          'super-manager',
          'engineer-allocation',
        ],
      },
      {
        title: 'Facilities',
        route: 'facility',
        icon: 'fa-solid fa-landmark-flag',
        action: 'browes',
        role: ['admin', 'manager', 'super-manager', 'markter'],
      },
    ],
  },
  {
    title: 'Task Management',
    icon: 'fa-solid fa-bars-progress',
    route: 'task-management-all-stuatus',
    role: [
      'admin',
      'manager',
      'super-manager',
      'process-manager',
      'hr',
      'hr-office',
      'accountant',
      'super-accountant',
      'markter',
      'engineer-allocation',
      'engineer',
      'office-manager',
      'quality',
    ],
  },
  {
    title: 'Generate Report',
    icon: 'fa-solid fa-floppy-disk',
    action: 'browes',
    role: [
      'admin',
      'process-manager',
      'engineer-allocation',
      'quality',
      'super-manager',
    ],
    children: [
      {
        title: 'Create report',
        route: 'auto-generate-report',
        icon: 'fa-regular fa-circle',
        action: 'browes',
        role: [
          'admin',
          'process-manager',
          'engineer-allocation',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Templates',
        route: 'templates-auto-generate-report',
        icon: 'fa-regular fa-circle',
        action: 'browes',
        role: [
          'admin',
          'process-manager',
          'engineer-allocation',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Word Templates',
        route: 'report',
        icon: 'fa-regular fa-circle',
        action: 'browes',
        role: [
          'admin',
          'manager',
          'process-manager',
          'engineer-allocation',
          'quality',
          'super-manager',
        ],
      },
    ],
  },
  {
    title: 'Analysis',
    route: 'analysis',
    icon: 'fa-solid fa-chart-gantt',
    role: [
      'admin',
      'manager',
      'process-manager',
      'hr',
      'hr-office',
      'quality',
      'super-manager',
    ],
  },
  {
    title: 'Branches',
    route: 'branch-accounts',
    img: 'branch.png',
    role: ['super-manager'],
  },
  {
    title: 'Bank Accounts',
    route: 'bank-accounts',
    // icon: 'fa-solid fa-money-bill',
    img: 'bank-account.png',

    role: ['super-manager', 'office-manager', 'accountant', 'super-accountant'],
  },
  {
    title: 'Currency',
    route: 'currency-accounts',
    img: 'currency.png',
    role: ['super-manager'],
  },
  {
    title: 'Zoho Report',
    route: 'zoho-reports',
    // icon: 'fa-solid fa-money-bill',
    img: 'reporting.png',
    role: ['super-manager'],
  },
  // {
  //   title: 'Support Chat',
  //   route: 'support',
  //   icon: 'fa-regular fa-comment',
  //   action: 'browes',
  //   role: ['admin', 'manager', 'markter', 'super-manager'],
  // },
  {
    title: 'Government',
    route: 'government',
    icon: 'fa-solid fa-code-pull-request',
    action: 'browes',
    role: ['government', 'super-manager'],
  },
  {
    title: 'Required Documents',
    route: 'required-documents',
    icon: 'fa-solid fa-file',
    action: 'browes',
    role: ['super-manager', 'hr', 'hr-office', 'office-manager'],
  },
  {
    title: 'Complaints',
    icon: 'fa-solid fa-bullhorn',
    role: [
      'admin',
      'hr',
      'hr-office',
      'office-manager',
      'engineer-allocation',
      'engineer',
      'quality',
      'super-manager',
    ],
    children: [
      {
        title: 'Complaint',
        route: 'index-complaint',
        icon: 'fa-regular fa-circle',
        action: 'browes',
        role: ['super-manager'],
        permissions: ['complaint', 'complaint_by_office'],
      },
      {
        title: 'Assigned',
        route: 'assigned-complaint',
        icon: 'fa-regular fa-circle',
        action: 'browes',
        role: [
          'admin',
          'accountant',
          'super-accountant',
          'engineer-allocation',
          'engineer',
          'quality',
          'super-manager',
        ],
      },
      {
        title: 'Responsible',
        route: 'responsible-complaint',
        icon: 'fa-regular fa-circle',
        action: 'browes',
        role: [
          'admin',
          'accountant',
          'super-accountant',
          'engineer-allocation',
          'engineer',
          'quality',
          'super-manager',
        ],
      },
    ],
  },
  {
    title: 'Salary',
    route: 'salary',
    icon: 'fa-solid fa-dollar-sign',
    role: ['salary', 'salary_by_office', 'super-manager'],
    permissions: ['salary', 'salary_by_office'],
  },
  {
    title: 'Payroll',
    icon: 'fa-solid fa-file-invoice-dollar',
    route: 'payroll',
    action: 'browes',
    role: ['super-manager'],
    permissions: ['salary', 'salary_by_office'],
  },
  {
    title: 'Operations Center',
    icon: 'fa-solid fa-gears',
    externalAuthLink: 'https://ce.gulftic.com/operations-center',
    role: ['super-manager'],
    permissions: ['inspection_location'],
  },
]
